import { useEffect, useState } from 'react';
import { ICompanyDataModel } from '../../data-models/company.data-model';
import { useRemoveCompanyDataJ, useSaveCompanyDataJ } from '../../services/hooks/useSaveCompanyData';

/**
 * Puts the sample companies into the app's company store while the caller is mounted, for live
 * pieces that look companies up there directly; they leave with it. Returns true once seeded.
 */
export function useSeedSampleCompanies(companies: ICompanyDataModel[]): boolean {
  const saveCompanies = useSaveCompanyDataJ();
  const removeCompanies = useRemoveCompanyDataJ();
  const [seeded, setSeeded] = useState(false);

  useEffect(() => {
    saveCompanies(companies);
    setSeeded(true);
    return () => {
      removeCompanies(companies.map((company) => company.id));
    };
  }, [companies, saveCompanies, removeCompanies]);

  return seeded;
}
